import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/style.css";
import { Link, useHistory } from "react-router-dom";
import { baseUrl, awsImageURL } from "../../api/ipconfig";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Milage from "../../images/mileage.png";
import Automatic from "../../images/automatic.png";
import Manual from "../../images/manual.png";
import { AuthContext } from "../../context/AuthContext";
import { MemberBanner, CarSuggest } from "../banners/banner";
import moment from "moment-timezone";
import TPLBannerImg from "../../images/tpl-banner-btm.jpg";
import AddCard from "../AddCard/AddCard";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AdsResult({ postData, featuredData, loading }) {
  const { user } = React.useContext(AuthContext);

  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const addToWishlist = async (post_id) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("post_id", post_id);
      formData.append("Id", user?.id);
      await axios.post(`${baseUrl}/fame/addToWishlist`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const response = await axios.get(`${baseUrl}/posts/condition`, {
        params: {
          condition: "used",
        },
      });
      const updatedWishlistData = response?.data?.data;

      setData(updatedWishlistData);

      setStatusMsg("Added to saved ads");
      setOpen(true);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };
  const removeFromWishlist = async (post_id) => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(`${baseUrl}/fame/deletewishlist`, {
        params: {
          userId: user?.id,
          post_id: post_id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const response = await axios.get(`${baseUrl}/posts/condition`, {
        params: {
          condition: "used",
        },
      });
      const updatedWishlistData = response?.data?.data;

      setData(updatedWishlistData);

      setStatusMsg("Remove from saved ads");
      setOpen(true);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const firstFeatured = featuredData && featuredData.slice(0, 9);
  const secondFeatured = featuredData && featuredData.slice(10, 19);

  const loadingLoop = [1, 2, 3, 4];

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleBarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
      {loading ? (
        <div className="No_ads_loading p-3 text-center">
          <div>
            {loadingLoop?.map((item) => (
              <div className="row mb-4">
                <div className="col-lg-3">
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width="100%"
                    height={170}
                  />
                </div>
                <div className="col-lg-9 d-flex flex-column justify-content-between">
                  <div className="d-flex align-items-top justify-content-between">
                    <div className="text-start">
                      <h4>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={300}
                          height={20}
                        />
                      </h4>
                      <h6>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={150}
                          height={20}
                        />
                      </h6>
                    </div>
                    <div>
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={8}
                        height={20}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center ">
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                  </div>
                  <div>
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={60}
                      height={20}
                    />
                  </div>
                  <div className=" d-flex justify-content-end ">
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={100}
                      height={35}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : featuredData && featuredData?.length ? (
        <>
          {firstFeatured && firstFeatured.map((ad) => <AddCard ad={ad} />)}

          {firstFeatured?.length > 0 && (
            <div className="text-center">
              <div
                className="d-none d-md-inline"
                id="div-gpt-ad-1743150953244-0"
                style={{ minHeight: "250px", minWidth: "970px" }}
              ></div>
            </div>
          )}

          {secondFeatured && secondFeatured.map((ad) => <AddCard ad={ad} />)}

          {secondFeatured?.length > 0 && (
            <div className="text-center">
              {/* Search Page Between Ad */}
              <div
                className="d-none d-md-inline"
                id="div-gpt-ad-1743151047455-0"
                style={{ minHeight: "90px", minWidth: "728px" }}
              ></div>
            </div>
          )}

          {secondFeatured?.length > 0 && <CarSuggest />}
          {/* {firstFeatured?.length > 0 && <MemberBanner />} */}
        </>
      ) : (
        <MemberBanner />
      )}

      {loading ? (
        <div className="No_ads_loading p-3 text-center">
          <div>
            {loadingLoop?.map((item) => (
              <div className="row mb-4">
                <div className="col-lg-3">
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width="100%"
                    height={170}
                  />
                </div>
                <div className="col-lg-9 d-flex flex-column justify-content-between">
                  <div className="d-flex align-items-top justify-content-between">
                    <div className="text-start">
                      <h4>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={300}
                          height={20}
                        />
                      </h4>
                      <h6>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={150}
                          height={20}
                        />
                      </h6>
                    </div>
                    <div>
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={8}
                        height={20}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center ">
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                  </div>
                  <div>
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={60}
                      height={20}
                    />
                  </div>
                  <div className=" d-flex justify-content-end ">
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={100}
                      height={35}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : postData && postData?.length ? (
        postData && postData.map((ad) => <AddCard ad={ad} />)
      ) : (
        <div className="No_ads p-3 text-center">
          <p>no Available ads</p>
        </div>
      )}
    </>
  );
}
